import classNames from 'classnames';

import { ForwardMessage } from '../../components/ForwardMessage/ForwardMessage';
import { QuotedMessage } from '../../components/QuotedMessage/QuotedMessage';
import styles from './styles.m.css';

const Header = ({ message, isShowForward }) => {
  return (
    <div
      className={classNames(styles.header, {
        [styles.forward]: isShowForward,
      })}
    >
      <QuotedMessage
        message={message}
        theme={'2'}
      />
      {isShowForward && (
        <ForwardMessage
          message={message}
          theme={'2'}
        />
      )}
    </div>
  );
};

export default Header;
